export const convertValueToLocale = (
  value: number | string,
  digits: number = 0,
  currency: string = "€",
  defaultValue: string = "0"
) => {
  if (value === null || value === undefined) {
    return defaultValue;
  }

  const valueNumber = Number(value);

  if (isNaN(valueNumber)) {
    return defaultValue;
  }

  if (valueNumber % 1 === 0) {
    const formattedValue = Math.abs(valueNumber).toLocaleString("de-DE", {
      minimumFractionDigits: currency === "€" ? 0 : digits,
      maximumFractionDigits: currency === "€" ? 0 : digits,
    });
    return valueNumber < 0
      ? `-${formattedValue}${currency}`
      : `${formattedValue}${currency}`;
  } else {
    const formattedValue = Math.abs(valueNumber).toLocaleString("de-DE", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });

    return valueNumber < 0
      ? `-${formattedValue}${currency}`
      : `${formattedValue}${currency}`;
  }
};

export const convertValueToLocaleForm = (
  value: number | string,
  digits: number | "auto" = "auto"
) => {


  if (value === null || value === undefined) {
    return "0";
  }

  const valueNumber = Number(value);

  if (isNaN(valueNumber)) {
    return "0";
  }

  let actualDigits: number = typeof digits === "number" ? digits : 2;

  if (digits === "auto") {
    const valueString = valueNumber.toString();
    const decimalIndex = valueString.indexOf(".");

    if (decimalIndex === -1) {
      actualDigits = 0;
    } else {
      const decimalPart = valueString.substring(decimalIndex + 1);

      const trimmedDecimal = decimalPart.replace(/0+$/, "");

      if (trimmedDecimal === "") {
        actualDigits = 0;
      } else if (trimmedDecimal.length === 1 && trimmedDecimal.endsWith("0")) {
        actualDigits = 1;
      } else {
        actualDigits = 2;
      }
    }
  }

  const formattedValue = Math.abs(valueNumber).toLocaleString("de-DE", {
    minimumFractionDigits: actualDigits,
    maximumFractionDigits: actualDigits,
  });

  return valueNumber < 0 ? `-${formattedValue}` : `${formattedValue}`;
};

export const convertLocaleValueToNumber = (value: string) => {
  return Number(value.toString().replace(".", "").replace(",", "."));
};
